import { render, staticRenderFns } from "./AlignmentProperties.vue?vue&type=template&id=3f605738&scoped=true"
import script from "./AlignmentProperties.vue?vue&type=script&lang=js"
export * from "./AlignmentProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f605738",
  null
  
)

export default component.exports